import type { ReactElement } from "react";

/**
 * Icône « WhatsApp + » (bulle WhatsApp avec un plus), dessinée pour le CRM. Mêmes attributs que
 * les icônes lucide : trait `currentColor`, taille en px. Tracés copiés tels quels du dessin validé.
 */
export function WhatsAppIcon({
  size = 16,
  className,
}: {
  size?: number;
  className?: string;
}): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
    >
      <path d="M20.95 10.75A9 9 0 0 1 7.9 20L2 22l2-5.9A9 9 0 0 1 13.25 3.05" />
      <path stroke="none" fill="currentColor" transform="translate(6.6 6.6) scale(0.45)" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
      <path d="M19.8 1.2v6.4M16.6 4.4h6.4" />
    </svg>
  );
}
